import { defineStore } from "pinia";

const defaultNotificationData = { message: null, timeout: 3000, color: "green" };

interface State {
  globalNotification: { message: string | null; timeout: number; color: string };
}

export const useNotificationStore = defineStore("notification", {
  state: (): State => ({
    globalNotification: defaultNotificationData
  }),
  actions: {
    setSuccessNotification(message: string) {
      this.globalNotification = {
        message: message,
        timeout: 3000,
        color: "green"
      };
    },
    setErrorNotification(message: string) {
      this.globalNotification = {
        message: message,
        timeout: -1,
        color: "red"
      };
    },
    clearNotification() {
      this.globalNotification = defaultNotificationData;
    }
  }
});
